import React from 'react';
import AD from 'react-google-publisher-tag';
import _ from 'lodash';
import './Bio.css';

const Bio = ({ text, data }) => (
  <div>
    <div className="banner-ad-container">
      <AD path={_.get(data, 'metadataMap.bannerAdTag')} dimensions={[[970,90],[728,90],[320,50]]}/>
    </div>
    <div className='player-paragraph' dangerouslySetInnerHTML={{
      __html: `${(text || 'No bio at the moment.')}`
    }} />
  </div>
)

export default Bio;